import _ from "lodash";
import { parse, stringify } from "querystring";
import { nullish } from "./nullish";
import { Kinds } from "constants/product-collection";
import { ColumnType } from "helpers/query-dsl-types";

export const addQueryParam = (url: string, ...params: { [key: string]: string | number }[]) => {
    const [base, query] = _.split(url, "?");
    const newQuery = { ...parse(query), ..._.merge({}, ...params) };
    return !_.isEmpty(newQuery) ? `${base}?${stringify(newQuery)}` : base;
};

// this flatten nested objects and concatenate the keys with dots
export const flattenParams = (data, root = "", aggregator = {}) => {
    return Object.keys(data).reduce((acc, key) => {
        const value = data[key];
        const newKey = root ? `${root}.${key}` : key;
        if (typeof value === "object" && !nullish(value) && Object.keys(value).length) {
            return flattenParams(value, newKey, acc);
        }

        acc[newKey] = value;
        return acc;
    }, aggregator);
};

export const getFilterFieldType = (schemaField) => {
    return schemaField?.get("kind") === Kinds.FORMULA && schemaField?.get("rowwise_evaluation") === true
        ? ColumnType.BulkFormulaField
        : ColumnType.ItemField;
};
